export default __webpack_public_path__ + "static/media/f_wdt_c_6.d701b844.mp3";